import { render, staticRenderFns } from "./custom-rate.vue?vue&type=template&id=149ce143&scoped=true&"
import script from "./custom-rate.vue?vue&type=script&lang=js&"
export * from "./custom-rate.vue?vue&type=script&lang=js&"
import style0 from "./custom-rate.vue?vue&type=style&index=0&id=149ce143&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149ce143",
  null
  
)

export default component.exports